import { Box, Button, Card, Grid, IconButton, Skeleton, Typography } from "@mui/material";
import Loading from "../../load/loading";
import HeaderGestorConfigs from "../../utils/headerGestorConfigs";
import QRCode from "../../qrCode/qrCode";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import printerService from "../../services/printer";
import FotoEdit from "../../utils/fotoEdit";
import ChangeStatusAdmin from "./changeStatusAdmin";
import AssinaturaUser from "./assinaturaUser";
import CarimboUser from "./carimboUser";
import EditeSenha from "./editeSenha";
import api from "../../services/api";
import GerenciarPrivilegios from "./privilegios";
import './fichaAdmin.css';
// import ShortNome from "../../utils/ShortNome";
import { useParams } from "react-router-dom";
import VerifyPermission from "../../utils/verifyPermission";
import InfoFieldGroup from "../../utils/InfoField/InfoFieldGroup";
import ShortNome from "../../utils/ShortNome";
import Editor from "../../ckeditor/editor";
import EditIcon from '@mui/icons-material/Edit';
import HablitarChat from "../../utils/hablitarChat";

export default function FichaAdmin({ admin, local, setHandleUpdate }) {
  const user = useSelector((state) => state.account.user);
  const [isEdit, setIsEdit] = useState(false);
  const [editDados, setEditDados] = useState(false);
  const [dadosPessoalAdmin, setDadosPessoalAdmin] = useState(admin);
  const [openEditFoto, setOpenEditFoto] = useState(false);
  const [openRepresentante, setOpenRepresentante] = useState(false)
  const [openConfirm, setOpenConfirm] = useState(false)
  const [categorias, setCategorias] = useState([]);
  const [loading, setLoad] = useState(false);
  const [loadiEtid, setLoadEdit] = useState(false);
  const [messegeSuccess, setMessageSuccess] = useState('');
  const [messegeError, setMessageError] = useState('');
  const baseUrl = window.location.origin;
  const { id } = useParams();

  const [dadosRepresentante, setDadosRepresentante] = useState({
    userId: user?._id,
    ordem: '',
    numeroCarteira: '',
    adminId: dadosPessoalAdmin?._id,
    categoriaId: ''
  })

  const handleCloseRepresentante = () => { setOpenRepresentante(false) }
  const handleCloseConfirm = () => { setOpenConfirm(false) }

  useEffect(() => {

    api.get('/categoria-tecnico')
      .then((res) => setCategorias(res.data.categoriaTecnicos))
      .catch((err) => 'console.log(err)')
  }, [])

  const changeToRepresentante = () => {
    setLoad(true);
    api.post('/admin/become-representante', {
      adminId: dadosPessoalAdmin?._id,
      userId: user?._id
    })
      .then((res) => setMessageSuccess('O usuário agora é um representante'))
      .catch(() => setMessageError('Não foi Possivel tornar - lo representante'))
      .finally(() => setLoad(false))
  }
  const changeToDirectorTecnico = () => {
    setLoad(true);
    api.post('/admin/become-tecnico', dadosRepresentante)
      .then((res) => {
        handleCloseConfirm();
        setMessageSuccess('Usuário aprovado como Director Técnico')
      })
      .catch((err) => {
        handleCloseConfirm();
        setMessageError(err.response.data.msg)
      })
      .finally(() => setLoad(false))
  }

  const handleChange = (event) => {
    setDadosRepresentante({ ...dadosRepresentante, [event.target.name]: event.target.value });
  }

  const printQrCode = (qrCodeAdmin) => {
    var preview = document.getElementById(qrCodeAdmin);
    preview.style = "display: '' ";
    printerService.printer(qrCodeAdmin);
    preview.style = "display: none";
  };

  const [municipios, setMunicipios] = useState([]);
  const [provincias, setProvincias] = useState([]);
  const titular = [{ designacao: 'Sim' }, { 'designacao': 'Não' }]
  const titulo = [{ designacao: 'Directores' }, { 'designacao': 'Chefes de Departamento' }]

  useEffect(() => {
    if (isEdit) {
      api.get('/provincias')
        .then(res => {
          setProvincias(res.data.provincias);
        }).catch(err => '')
    }
  }, [isEdit])

  useEffect(() => {
    if (editDados?.provinciaId) {
      api.get(`/municipios-by-provincia/${editDados?.provinciaId}`)
        .then(res => {
          setMunicipios(res.data.municipios);
          setEditDados((prev) => ({ ...prev, provincia: res.data.provincia.designacao }));
        }).catch(err => 'console.log(err)')
    }
  }, [editDados?.provinciaId])


  const submitEdit = async () => {
    setLoadEdit(true)
    setMessageSuccess('')
    setMessageError('')

    await api.put('/dados-pessoais/edit', { ...editDados, dadosPessoaisId: admin?.dadosPessoais?._id, 'userId': user?._id ?? '', biografia: editDados?.conteudo ?? dadosPessoalAdmin?.biografia })
      .then(res => {
        setMessageSuccess(res.data.msg)
        setDadosPessoalAdmin(res.data)
        setLoadEdit(false)

        setIsEdit(false)
        setEditDados(false)

      }).catch(err => {
        setLoadEdit(false)
        setMessageError(err.response.data.message)
      })
  }

  return (
    <>
      {admin ? (
        <Card style={{ padding: 10, minHeight: "20vh", }}>
          <HeaderGestorConfigs
            menu={local === "perfilAdmin" ? true : false}
            title={
              editDados === "gerenciarPrivilegios" ?
                <>
                  <ShortNome nome={dadosPessoalAdmin?.dadosPessoais?.nome} />{" "}
                  ( {dadosPessoalAdmin?.funcao} )
                </>
                : 'Ficha do Administrador'
            }
            configArea={"fichaAdmin"}
            editDados={editDados}
            setEditDados={setEditDados}
            setIsEdit={setIsEdit}
            dadosPessoalAdmin={dadosPessoalAdmin}
            setOpenEditFoto={setOpenEditFoto}
            printQrCode={printQrCode}
            openRepresentante={openRepresentante}
            setOpenRepresentante={setOpenRepresentante}
            openConfirm={openConfirm}
            setOpenConfirm={setOpenConfirm}
            categorias={categorias}
            dadosRepresentante={dadosRepresentante}
            setDadosRepresentante={setDadosRepresentante}
            handleCloseRepresentante={handleCloseRepresentante}
            handleCloseConfirm={handleCloseConfirm}
            changeToRepresentante={changeToRepresentante}
            changeToDirectorTecnico={changeToDirectorTecnico}
            handleChange={handleChange}
            load={loading}
            messegeSuccess={messegeSuccess}
            messegeError={messegeError}
          />

          {(!editDados || isEdit) &&
            <Box className="profile-container">
              <div className="profile-card">
                <Grid container  >

                  {/* Image Section */}
                  {!isEdit &&
                    <Grid item xs={12} sm>
                      <div >
                        {loading ? (
                          <Skeleton variant="rectangular" width="100%" height="100%" animation="wave" />
                        ) : (
                          <div style={{ position: 'relative' }}>
                            <img
                              src={dadosPessoalAdmin?.dadosPessoais?.fotoURL}
                              alt="Profile"
                              style={{ width: '100%' }}
                            />

                            <IconButton
                              style={{
                                position: 'absolute',
                                bottom: '20px',
                                right: '10px',
                                padding: 6,
                                borderRadius: '50%',
                                backgroundColor: '#ffffff',
                                boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.1)',
                              }}
                              onClick={() => setOpenEditFoto(true)}
                              className="tw-text-primary hover:tw-text-primary-dark"
                            >
                              <EditIcon />
                            </IconButton>
                          </div>
                        )}

                        <Typography
                          style={{
                            borderRadius: 5,
                            background: "#99288b",
                            color: "#fff",
                            padding: 3,
                            marginTop: -10,
                          }}
                          align="center"
                          variant="subtitle1"
                        >
                          <strong style={{
                            marginTop: 15,
                          }}>Função </strong>
                          <br />
                          {dadosPessoalAdmin?.funcao}
                        </Typography>
                      </div>

                      <HablitarChat userDados={dadosPessoalAdmin} />
                    </Grid>
                  }

                  <Grid item xs={12} sm={isEdit ? 12 : 8}>
                    <div className="profile-info-section">
                      <div className="profile-qr-container">
                        <div className="profile-qr-box">
                          {loading ? (
                            <Skeleton variant="rectangular" width={80} height={80} animation="wave" />
                          ) : (
                            <QRCode
                              link={`${baseUrl}/verifica-tecnico/${dadosPessoalAdmin?._id}`}
                              size={80}
                            />
                          )}
                        </div>
                      </div>

                      <div className="profile-info-content">
                        <div className="profile-name-section">
                          {loading ? (
                            <Skeleton variant="text" width={200} height={60} animation="wave" />
                          ) : (
                            <h1 className="profile-name-title">
                              {dadosPessoalAdmin?.dadosPessoais?.nome || "N/A"}
                            </h1>
                          )}
                          <div className="profile-name-underline"></div>
                        </div>

                        {loading ? (
                          <>
                            <Skeleton variant="text" width={180} height={20} animation="wave" />
                            <Skeleton variant="text" width={180} height={20} animation="wave" />
                          </>
                        ) : (
                          <div >
                            <InfoFieldGroup
                              submit={submitEdit}
                              data={editDados}
                              handleChange={handleChange}
                              setIsEdit={setIsEdit}
                              isEdit={isEdit}
                              load={loadiEtid}
                              fields={
                                [
                                  // { label: 'Estado', value: <StatusSolicitacoes status={?.status} />, editable: false, },
                                  { label: 'Nome', value: dadosPessoalAdmin?.dadosPessoais.nome, key: 'nome', onChange: (v) => setEditDados({ ...editDados, nome: v.target.value }) },
                                  { label: 'BI', value: dadosPessoalAdmin?.dadosPessoais.numeroBI, key: 'numeroBI', onChange: (v) => setEditDados({ ...editDados, numeroBI: v.target.value }) },
                                  { label: 'Departamento', value: dadosPessoalAdmin?.departamento, key: 'departamento', editable: false, onChange: (v) => setEditDados({ ...editDados, departamento: v.target.value }) },
                                  { label: 'Secção', value: dadosPessoalAdmin?.seccao, key: 'seccao', editable: false, onChange: (v) => setEditDados({ ...editDados, seccao: v.target.value }) },
                                  { label: 'Agente', value: dadosPessoalAdmin?.numeroAgente, key: 'numeroAgente', editable: false, onChange: (v) => setEditDados({ ...editDados, numeroAgente: v.target.value }) },
                                  { label: 'Telefone1', value: dadosPessoalAdmin?.dadosPessoais?.tel1, key: 'tel1', onChange: (v) => setEditDados({ ...editDados, tel1: v.target.value }) },
                                  { label: 'E-mail Pessoal', value: dadosPessoalAdmin?.dadosPessoais?.email, key: 'emailPessoal', onChange: (v) => setEditDados({ ...editDados, emailPessoal: v.target.value }) },
                                  { label: 'Telefone2', value: dadosPessoalAdmin?.dadosPessoais?.tel2, key: 'tel2', onChange: (v) => setEditDados({ ...editDados, tel2: v.target.value }) },
                                  { label: 'E-mail', value: dadosPessoalAdmin?.dadosPessoais?.email, key: 'email', onChange: (v) => setEditDados({ ...editDados, email: v.target.value }) },
                                  { label: 'Provincia', value: dadosPessoalAdmin?.dadosPessoais.provincia, key: 'provinciaId', type: 'select', options: provincias, onChange: (v) => setEditDados({ ...editDados, provinciaId: v.target.value }) },
                                  { label: 'Município', value: dadosPessoalAdmin?.dadosPessoais.municipio, key: 'municipio', type: 'select', options: municipios, onChange: (v) => setEditDados({ ...editDados, municipio: v.target.value }) },
                                  { label: 'Bairro', value: dadosPessoalAdmin?.dadosPessoais?.bairro, key: 'bairro', onChange: (v) => setEditDados({ ...editDados, bairro: v.target.value }) },
                                  { label: 'Rua / Avenida', value: dadosPessoalAdmin?.dadosPessoais?.rua, key: 'rua', onChange: (v) => setEditDados({ ...editDados, rua: v.target.value }) },
                                  { label: 'Titular (Se faz parte da direcção da instituição)', value: dadosPessoalAdmin?.titular, key: 'titular', type: 'select', options: titular, onChange: (v) => setEditDados({ ...editDados, titular: v.target.value }) },
                                  { label: 'Titulo', value: dadosPessoalAdmin?.titulo, key: 'titulo', type: 'select', options: titulo, onChange: (v) => setEditDados({ ...editDados, titulo: v.target.value }) },
                                  { label: 'Data de Nomeção', value: dadosPessoalAdmin?.dataNomeacao, key: 'dataNomeacao', type: 'date', onChange: (v) => setEditDados({ ...editDados, dataNomeacao: v.target.value }) },
                                ]
                              } >

                              {isEdit &&
                                <>
                                  {/* biografia: */}
                                  <Typography variant="subtitle1" style={{ marginTop: 20, fontWeight: 'bold' }}>
                                    Biografia:
                                  </Typography>
                                  <Editor setEditorData={setEditDados} editorData={dadosPessoalAdmin?.biografia} />
                                </>
                              }
                            </InfoFieldGroup>

                            {id &&
                              <VerifyPermission permissions={user?.permissions} permission={'allPermission'}>
                                <div className="tw-flex tw-flex-col tw-gap-4 tw-p-1 tw-border tw-border-gray-200 tw-rounded-xl tw-bg-slate-50">
                                  <span className="tw-text-xs tw-font-semibold tw-text-gray-500 tw-p-3">Gerenciar o estado, função, assinatura e carimbo do administrador</span>
                                  
                                  <ChangeStatusAdmin
                                    admin={admin}
                                    setHandleUpdate={setHandleUpdate}
                                  />
                                  <AssinaturaUser
                                    admin={admin}
                                    setHandleUpdate={setHandleUpdate}
                                  />
                                  <CarimboUser
                                    admin={admin}
                                    setHandleUpdate={setHandleUpdate}
                                  />
                                </div>
                              </VerifyPermission>
                            }

                            {dadosPessoalAdmin?.assinatura && (
                              <div className="profile-signature">
                                <img
                                  src={dadosPessoalAdmin?.assinatura}
                                  alt="Assinatura"
                                />
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  </Grid>
                </Grid>
              </div>
            </Box>
          }

          {editDados === "senha" && (
            <EditeSenha user={admin} cancelEdite={setEditDados} />
          )}

          {editDados === "gerenciarPrivilegios" && (
            <GerenciarPrivilegios user={admin} cancelEditPrivilegios={setEditDados} />
          )}

          {openEditFoto && (
            <FotoEdit
              openEditFoto={openEditFoto}
              setOpenEditFoto={setOpenEditFoto}
              dadosPessoal={dadosPessoalAdmin?.dadosPessoais}
              viewEdit={true}
            />)
          }
        </Card>
      ) : (
        <Loading />
      )
      }
    </>
  );
}
